'use client';

import React from 'react';

import { Users, Ticket, TrendingUp, Calculator } from 'lucide-react';

import ButtonLink from './ButtonLink';

const resources = [
  {
    icon: <Users className="h-6 w-6 text-white" />,
    title: '理財社群',
    description: '加入理財社群討論，獲取最新優惠資訊和理財建議',
    link: 'https://www.dcard.tw/f/money',
    linkLabel: 'Dcard 理財版',
  },
  {
    icon: <Ticket className="h-6 w-6 text-white" />,
    title: '優惠碼',
    description: '各大電商、外送平台最新優惠碼整理',
    link: 'https://couponmad.xyz/',
    linkLabel: 'CouponMad 抄你碼',
  },
  {
    icon: <TrendingUp className="h-6 w-6 text-white" />,
    title: '股票投資',
    description: '台股ETF、美股投資策略與分析資源',
    link: 'https://www.cmoney.tw/',
    linkLabel: 'CMoney 理財寶',
  },
  {
    icon: <Calculator className="h-6 w-6 text-white" />,
    title: '理財工具',
    description: '記帳、投資組合追蹤與理財規劃工具',
    link: 'https://www.moneydj.com/',
    linkLabel: 'MoneyDJ 理財網',
  },
];

const MoneyResources: React.FC = () => {
  return (
    <div className="bg-gray-50 dark:bg-gray-900/50">
      <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-base font-semibold text-indigo-600 dark:text-indigo-400 tracking-wide uppercase">
            精選資源
          </h2>
          <p className="mt-2 text-3xl font-extrabold text-gray-900 dark:text-white tracking-tight sm:text-4xl">
            讓你的錢更聰明
          </p>
          <p className="mt-4 max-w-2xl mx-auto text-xl text-gray-500 dark:text-gray-400">
            我們為您整理了最實用的理財工具與社群，助您輕鬆掌握財務狀況。
          </p>
        </div>
        <div className="mt-12">
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
            {resources.map(resource => (
              <div key={resource.title} className="pt-6">
                <div className="flow-root bg-white dark:bg-gray-800 rounded-lg px-6 pb-8 shadow-lg transform hover:-translate-y-2 transition-transform duration-300 h-full">
                  <div className="-mt-6">
                    <div>
                      <span className="inline-flex items-center justify-center p-3 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-md shadow-lg">
                        {resource.icon}
                      </span>
                    </div>
                    <h3 className="mt-8 text-lg font-medium text-gray-900 dark:text-white tracking-tight">
                      {resource.title}
                    </h3>
                    <p className="mt-5 text-base text-gray-500 dark:text-gray-400">
                      {resource.description}
                    </p>
                  </div>
                  <div className="mt-auto pt-6">
                    <ButtonLink
                      link={resource.link}
                      className="w-full text-center bg-indigo-600 hover:bg-indigo-700 dark:bg-indigo-500 dark:hover:bg-indigo-400 text-white px-4 py-2 rounded-lg text-sm transition-colors duration-300"
                    >
                      {resource.linkLabel}
                    </ButtonLink>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MoneyResources;
